export const getLink = (link) => link?.Title?.toLowerCase()?.replace(/[^a-zA-Z0-9]/g,'-')